"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.A11Y_COUNTDOWN_LABEL = exports.EXPIRED_BUTTON_SECONDARY_LINK = exports.EXPIRED_BUTTON_PRIMARY = exports.EXPIRED_DESCRIPTION = exports.EXPIRED_TITLE = exports.WARNING_BUTTON_SECONDARY_LINK = exports.WARNING_BUTTON_PRIMARY = exports.WARNING_DESCRIPTION = exports.WARNING_TITLE = void 0;
exports.WARNING_TITLE = 'mbSessionToExpire.modalHeader';
exports.WARNING_DESCRIPTION = 'mbSessionToExpire.modalDescription';
exports.WARNING_BUTTON_PRIMARY = 'mbSessionToExpire.modalNavigationKeepSessionOpenButton';
exports.WARNING_BUTTON_SECONDARY_LINK = 'mbSessionToExpire.modalNavigationCloseSessionLink';
exports.EXPIRED_TITLE = 'mbSessionExpired.modalHeader';
exports.EXPIRED_DESCRIPTION = 'mbSessionExpired.modalDescription';
exports.EXPIRED_BUTTON_PRIMARY = 'mbSessionExpired.modalNavigationReenterButton';
exports.EXPIRED_BUTTON_SECONDARY_LINK = 'mbModalSessionExpired.exitLink';
exports.A11Y_COUNTDOWN_LABEL = 'a11y.mbModalTimeOutModal.countdownLabelDescription';
exports.default = {
    TIMEOUT: {
        MODAL_WARNING: {
            TITLE: 'mbSessionToExpire.modalHeader',
            DESCRIPTION: 'mbSessionToExpire.modalDescription',
            BUTTON_PRIMARY: 'mbSessionToExpire.modalNavigationKeepSessionOpenButton',
            SECONDARY_LINK: 'mbSessionToExpire.modalNavigationCloseSessionLink',
            COUNTDOWN: {
                LABEL: 'a11y.mbModalTimeOutModal.countdownLabelDescription',
            },
        },
        MODAL_EXPIRED: {
            TITLE: 'mbSessionExpired.modalHeader',
            DESCRIPTION: 'mbSessionExpired.modalDescription',
            BUTTON_PRIMARY: 'mbSessionExpired.modalNavigationReenterButton',
            SECONDARY_LINK: 'mbModalSessionExpired.exitLink',
        },
    },
};
//# sourceMappingURL=index.js.map